import { render } from "./SummaryTable.vue?vue&type=template&id=3961811f&scoped=true&lang=pug"
import script from "./SummaryTable.vue?vue&type=script&lang=js"
export * from "./SummaryTable.vue?vue&type=script&lang=js"

import "./SummaryTable.vue?vue&type=style&index=0&id=3961811f&lang=scss&scoped=true"
import "./SummaryTable.vue?vue&type=style&index=1&id=3961811f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3961811f"]])

export default __exports__